export { default, type InfoCardTemplateProps } from './InfoCardTemplate';
